module.exports = __webpack_public_path__ + "media/images/favicons/pinned-tab-icon-ffcd1763ba705aa9a3a2f555bd0bf22f.svg";